import { render, staticRenderFns } from "./ConsignmentPackageItems.vue?vue&type=template&id=2b1ecb16"
import script from "./ConsignmentPackageItems.vue?vue&type=script&lang=js"
export * from "./ConsignmentPackageItems.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports